import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import ApplyCSS from '../../../../../components/ApplyCSS';
import commonUtil from './../../../../../utils/commonUtil';

import * as labelsActions from '../../../../../components/labels/actions';
import * as deliveryAddressActions from './actions';

import DeliveryAddressMultipleAddress from './components/deliveryAddressMultipleAddress';
import * as defaultConst from '../../../../../utils/clientConstant';
import * as flush from '../../../../createEvent/components/GiftRegistryNewAddress/actions';

import Tagging from '../../../../../components/Tagging/Tagging';
import Warning from '../../../../../components/Warning2';
import ButtonsFooter from './components/buttonsFooter';
import AddAditionalAddressButton from './components/addAditionalAddressButton';
import AddAddressModal from './components/addAddressModal';
import Warning2 from '../../../../../components/Warning2';
import InputButton from '../../../../../components/ZUILib/InputButton';
const pageName = 'eventInfo';
const channel = commonUtil.getChannel();
const { getDeliveryAddressInfo, hanldeAddressCelebrityMapping, getAddressData, getState, resetAddress, flushAddressSearch,updateEventDeliveryAddress, loadProfileAddress } = deliveryAddressActions;

const applicationRoutes = commonUtil.getApplicationRoutes();

@connect(store => ({
  store,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  stateList: store.createEvent.dataState,
}),
  { ...labelsActions, ...deliveryAddressActions, ...flush })

class DeliveryAddress extends Component {
  celebrityMapping = [];
  constructor(props) {
    super(props);
    this.celebrityNameForMissingAddress = '';
    this.state = {
      isModified: false,
      typeAlert: '',
      btnsaveRefValue: '',
      btncancelRefValue: '',
      celebratedSelected: {},
      selectedAddresId:[],
      enableUdpatebutton: false,
      enableAddAddressButton: false,
      showaddAddressModal: false,
      addressToAdd: props.deliveryAddress?.deliveryAddressInfo?.addressesToAdd || 0,
      profileAddresses: props.giftRegistryAddress || {},
    };
  }

  setRef = (ref) => {
    if (!ref) return;

    const refElements = {
      btnsave: () => this.setState({ ...this.state, btnsaveRefValue: ref }),
      btncancel: () => this.setState({ ...this.state, btncancelRefValue: ref }),
      noAction: () => {},
    };

    refElements[ref.props ? ref.props.htmlId : 'noAction']();
  }

  // * Redidect to show address form
  addAddress = () => {
    
    const eventId = this.props.eventId;
    const deliveryAddress = this.props.deliveryAddress;
    let allDeliveryAddressNickNames = deliveryAddress.deliveryAddressInfo.addresses.map(address => address.nickname);
    const storedAddressesJson = localStorage.getItem('saveGiftAddress');
    if (storedAddressesJson) {
      const storedAddresses = JSON.parse(storedAddressesJson);
      allDeliveryAddressNickNames = [...allDeliveryAddressNickNames, ...storedAddresses.map(address => address.nickname)];
    }
    browserHistory.push({
      pathname: applicationRoutes.addDeliveryAddress,      
      state: {
        fromDeliveryAddress: true,
        eventId,
        celebrityName: this.celebrityNameForMissingAddress,
        isEventManagement: true,
        deliveryAddressNickNames: allDeliveryAddressNickNames,
      },
    });

    //open it as modal
    // this.setState({
    //   showaddAddressModal : true
    // })

  }
  closeHandler = () =>{
      this.setState({
      showaddAddressModal : false
    })
  }

  // * When add aditional address should get celebrity name for request service
  setCelebrityNameForNewAddress = () => {
    const potentialUnassociated = {};
    const removeFunction = entryStr => entryStr.replace(/[^0-9]/g, '');

    const addressesMap = _.get(this.props, 'deliveryAddress.deliveryAddressInfo.addresses', [])
        .map(a => (a.celebMap ? a.celebMap : []));

    addressesMap.forEach((obj) => {
      obj.forEach((celeb) => {
        const celebKey = Object.keys(celeb).filter((item) => {
          if (Number(removeFunction(item))) {
            return item;
          }
          return null;
        })[0];

        const celebName = celeb[celebKey];

        if (celeb.associated === false) {
            // Si el nombre no está en el objeto, se inicializa
          if (!potentialUnassociated[celebName]) {
            potentialUnassociated[celebName] = 0;
          }
          potentialUnassociated[celebName] += 1;
        } else {
          delete potentialUnassociated[celebName];
        }
      });
    });

    const totalMaps = addressesMap.length;

    this.celebrityNameForMissingAddress = Object.keys(potentialUnassociated)
      .filter(name => potentialUnassociated[name] === totalMaps)[0];
  }

  // * Hide buttons save and cancel when press cancel
  hasAddressModified = () => {
    this.setState({
      isModified: true,
    });
  }

  // * Cancel modification of selector addresses
  cancelAddressModified = () => {
    if (this.addressReference) {
      this.addressReference.resetAllCelebritySelection();
    }
    this.setState({
      isModified: false,
    });
  }

  cancelAddNewAddress = () => {
    const { flushAddressSearch } = this.props; // eslint-disable-line no-shadow
    flushAddressSearch();
  }

  handleShowErrorOnCelebrityNoMapped = (show) => {
    const { deliveryAddress } = this.props;
    if (show) {
      // * alert
      this.updateWarningState({
        message: 'editEventDelivery.address.assign.party.warn',
        type: 'warning',
        complementary: [deliveryAddress.deliveryAddressInfo.addressesToAdd],
      });
    }
  }

  allowAlphanumeric = (e) => {
    const ctl = e.target.id;
    const limitLength = e.target.maxLength;
    const thisObj = document.querySelector('#' + ctl);
    const keyCode = e.input;
    // backspace, delete, left arrow and right arrow
    if (keyCode === 8 || keyCode === 9 || keyCode === 37 || keyCode === 39) {
      return true;
    }
    if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122)) {
      // numbers and numeric keypad
      if (thisObj.value.length >= limitLength) {
        e.preventDefault();
        e.stopPropagation();
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
    return true;
  }

  scrollUp = () => window.scrollTo(0, 0);

  UNSAFE_componentWillMount() {
    const eventIDFromProps = this.props.eventId
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : eventIDFromProps || null;
    if (eventID) {
      this.props.getDeliveryAddressInfo(eventID).then(() => {
        // this.props.loadProfileAddress();
        if (Number(this.props.deliveryAddress?.deliveryAddressInfo?.addressesToAdd) > 0) {
          this.setState({
            profileAddresses: this.props.giftRegistryAddress || {}
          });
          // this.props.loadProfileAddress().then(() => {
          //     this.setState({
          //     profileAddresses:this.props.giftRegistryAddress || {}
          //   });
          // });
        }
      });
    }
  }

  handleAddAddressTogift = () => {
    const { enableUdpatebutton, selectedAddresId } = this.state;
    const { deliveryAddress , giftRegistryAddress, eventManagementAddresses } = this.props;
    let selectedAddres = null
    if (enableUdpatebutton) {       
      // let storedAddress = localStorage.getItem('saveGiftAddress');
      // storedAddress = JSON.parse(storedAddress) || [];
      if (eventManagementAddresses && eventManagementAddresses.length > 0) {
       selectedAddres  = eventManagementAddresses.filter((address, index) => selectedAddresId.includes(address.addressId))
      }
      //loop through selectedAddres and change the nickName to nickname, then remove the nickName property
      selectedAddres = selectedAddres.map((address) => {
        const { nickName, ...rest } = address;
        return {
          ...rest,
          nickname: nickName || address.nickname, // copy nickName to nickname if present
          defaultAddress: address.defaultAddress || false,
          ecommAddressId: address.addressId || null
         }})  


      
      const dataRequest = [...selectedAddres]      
      const eventId = this.props.eventId;
      const profileId = this.props.user.result.profileId;
 
    updateEventDeliveryAddress(dataRequest, eventId, profileId).then((res) => {           
            if (res.body.status.status === 'success') {
              this.props.getDeliveryAddressInfo(eventId).then(() => {                
                if (Number(this.props.deliveryAddress?.deliveryAddressInfo?.addressesToAdd) > 0) {
                  this.setState({
                    profileAddresses: this.props.giftRegistryAddress || {}
                  });
                  // this.props.loadProfileAddress().then(() => {
                  //   this.setState({
                  //     profileAddresses: this.props.giftRegistryAddress || {}
                  //   });
                  // });
                }else{
                  this.setState({
                    profileAddresses:{}
                  })
                }
                 
              });
              this.setState({
                enableAddAddressButton: false,
                enableUdpatebutton: false,
              })
              
              this.props.showMessagePopUp(true,false,false,commonUtil.getLabel(
                this.props.lables.editEventDelivery,
                'dashboard.eventAddress.changedAssignedAddress.message',
              ));
            } else {
              if (res.body?.status?.status === defaultConst.constAPIFailure || res.body?.status?.status?.errorMessage) {
                this.props.showMessagePopUp(false,false,false, 
                  res.body.status.status.errorMessage || res.body.errorMessage || 'Ocurrió un error'
                );
              } else {
                this.props.showMessagePopUp(false,false,false, 'Ocurrió un error');
              } 
            } 
             this.scrollUp();
          }).catch((e) => {
            this.props.showMessagePopUp(false,false,false, 'Ocurrió un error. Intenta más tarde');
            this.scrollUp();
          });
    }
    //construct the payload which inclueded selected
    //address id and default as true

    //call the api
    
    // send the current address 
    // eventid
    // profile id
    // and defaultparam
     
  }

  handleDefaultSelect = (val) => {
    // will be getting index of selected addreses
    // selectedAddresId will have the index of address from 
    
    if (val.length > 0 && val.length < this.state.addressToAdd) {       
      this.setState({
        enableUdpatebutton: true,
        enableAddAddressButton: false,
        selectedAddresId: val
      });
    } else if (val.length > 0 && val.length == this.state.addressToAdd) {      
      this.setState({
        enableAddAddressButton: true,
        enableUdpatebutton: true,
        selectedAddresId: val
      })
    }
    else {
      this.setState({
        enableAddAddressButton: false,
        enableUdpatebutton: false,
        selectedAddresId: val
      })
    }
  }

  componentDidMount() {
    this.props.getState();
    if (!this.props.user) {
      browserHistory.push('/');
    }
    if (this.props.user &&
      this.props.user.result &&
      this.props.user.result.status.status === defaultConst.constAPIFailure) {
      browserHistory.push('/');
    }
    if (this.props.params && !this.props.params.eventID) {
      browserHistory.push('/');
    }

    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    const eventUrl = 'gestiondeeventos/DireccionDeEntrega/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Dirección de entrega',
      Site: 'Mesa de Regalos',
      idMesa: eventID,
    });
  }

  updateWarningState = ({ message, type, complementary = [''] }) => {
        this.setState({ ...this.state, typeAlert: type });
        if (this.alertMessage && typeof this.alertMessage.setMessage === 'function') {
            this.alertMessage.setMessage(commonUtil.getLabel(
                this.props.lables.editEventDelivery,
                message,
                complementary,
            ));
        } else {
            // Optionally, fallback to a console warning or other UI feedback
            console.warn('alertMessage ref is not set when trying to call setMessage');
        }
    }

  handleMySelection = (index, address, selectedValue) => {
    if (this.celebrityMapping && this.celebrityMapping.length === 0) {
      this.celebrityMapping.push({
        ['addressId' + (index + 1)]: address.addressId,
        ['celebrityId' + (index + 1)]: selectedValue.value,
      });
    } else {
      /*eslint-disable*/
      let newMapping = [];
      newMapping = this.celebrityMapping.filter((celebrity) => !celebrity.hasOwnProperty(['addressId' + (index + 1)]))
      newMapping.push({
        ['addressId' + (index + 1)]: address.addressId,
        ['celebrityId' + (index + 1)]: selectedValue.value,
      })
      this.celebrityMapping = newMapping;
      /*eslint-enable*/
    }
  }

  // * Run promise when save celebry with save button
  _hanldeAddressCelebrityMapping = () => {
    /*eslint-disable*/
    const userEventDetails = this.props.userEventDetails;

    const celebrityMappingArray = {};
    if (this.celebrityMapping.length > 0) {
      this.celebrityMapping.forEach((celeMap) => {
        for (const key in celeMap) {
          celebrityMappingArray[key] = celeMap[key];
        }
      });
    }

    if (userEventDetails && userEventDetails.eventDetailsInfo) {
      celebrityMappingArray.eventId = userEventDetails.eventDetailsInfo.eventId;
    } else {
      celebrityMappingArray.eventId = this.props.params.eventID;
    }

    hanldeAddressCelebrityMapping(celebrityMappingArray).then((response) => {
      const body = response.body;
      const { status: statusServer } = body || {};
      const { status, errorCode = '' } = statusServer;

      if (status === defaultConst.constAPISuccess) {
        this.setState({ ...this.state, isModified: false });
        this.celebrityMapping = [];

        this.props.getDeliveryAddressInfo(celebrityMappingArray.eventId).then((res) => {
          if(res.status.status === 'success') {
            this.updateWarningState({
              message: 'dashboard.eventAddress.changedAssignedAddress.message',
              type: 'success',
            });
          }
        });

        setTimeout(() => {
          this.celebrityMapping = [];
          this.cancelAddressModified();
        }, 1000);

        if (channel === 'wap') {
          // TODO: Review
          document.querySelector('.myEventContent').classList.remove('oppeningContainer');
        }
      } else if (status === defaultConst.constAPIFailure) {
        // * alerts
        // ! Occurs error in back when setting celebrities address for first time
        if (errorCode === '500') {
          this.updateWarningState({
            message: 'Ocurrió un error. Intenta más tarde',
            type: 'error',
          });
          return;
        }

        this.updateWarningState({
          message: 'editEventDelivery.address.assign.party.warn',
          type: 'error',
        });
      }
    }).catch((e) => {
      // * alert
      this.updateWarningState({
        message: 'Ocurrió un error. Intenta más tarde',
        type: 'error',
        complementary: [e.typeError],
      });
      /*eslint-disable*/
      console.log(e);
    });
  }

  // * Show button to add address for client
  isAvailableAddAddressWithForm = (eventID) => {
    const currentEventStatus = this.props.eventStatusInfo;
    const { constEventStatus } = defaultConst;
    const { SUSPENDED, VALIDITYOFFACTIVE, CLOSED } = constEventStatus;
    // for Suspended & closed event Status
    let eventStatusForSuspended = false;
    // currentEventStatus?.map((temp) => {
      // if (temp.eventId === eventID) {
        if ([SUSPENDED, VALIDITYOFFACTIVE, CLOSED].indexOf(currentEventStatus) > -1) {
          eventStatusForSuspended = true;
          if (currentEventStatus !== SUSPENDED) {
            if (document.querySelector('.addAddressButtonIcon')) {
              document.querySelector('.addAddressButtonIcon').style.display = 'none';
            }
          }
        }
      // } return eventStatusForSuspended;
    // });
 
    return eventStatusForSuspended;
  } 

  personSelectedToUpdateAddress = (celebrityPersonSelected) => {
    this.setState({ ...this.state, celebratedSelected: { ...celebrityPersonSelected } });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deliveryAddress && nextProps.deliveryAddress.deliveryAddressInfo && nextProps.deliveryAddress.deliveryAddressInfo.addresses) {
      this.celebrityMapping = [];
      nextProps.deliveryAddress.deliveryAddressInfo.addresses.forEach((add, index) => {
        if (add.celebMap) {
          let cele = '';
          /* eslint-disable */
          for (const obj of add.celebMap) {
            for (const i in obj) {
              cele = i;
              break;
            }
            break;
          }
          /* eslint-enable */
          this.celebrityMapping.push({
            ['addressId' + (index + 1)]: add.addressId,
            ['celebrityId' + (index + 1)]: cele,
          });
        }
      });
    }
  }

  render() {
    const { showaddAddressModal,enableUdpatebutton,enableAddAddressButton,profileAddresses} = this.state;
    const { lables, deliveryAddress } = this.props;
    console.log(this.props)
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : this.props.eventId ? this.props.eventId : null;
    const eventStatusForSuspended = this.isAvailableAddAddressWithForm(eventID);
    const filteredAddresidobj =  deliveryAddress?.deliveryAddressInfo?.addresses?.filter((address) => address.defaultAddress == true); 
    const defaultAddressid=  Array.isArray(filteredAddresidobj) && filteredAddresidobj[0]?.addressId || null;
    let actualizarDatos = {
      id: 'eventsubmitAddressbtn',
      type: 'button',
      name: 'Actualizar datos',
      value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.update.data'),
      classname: !this.state.enableUdpatebutton ? 'eventSubmitAddressbtnDisabled btnDisabled'  :"eventSubmitAddressbtn btnEnabled",
      onClickHandler: () => {
        // Handle clear filter action
        this.handleAddAddressTogift();

      },
      autoFocus: false,
      ariaLabel: 'eventsubmitAddressbtn',
      ariaHidden: false,      
      disabled:!this.state.enableUdpatebutton,
      cssStyle: this.state.enableUdpatebutton ? {
        backgroundColor: this.props.selectedTheme?.color_500,
        color: "#fff"
      } : {}
    };

    let Addressbackbutton ={
      id: 'Addressbackbutton',
      type: 'button',
      name: 'Regresar',
      value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.to.return')  || 'Regresar',
      classname: 'Addressbackbutton',
      onClickHandler: () => { 
        this.props.backtoMainHandler();
      },
      autoFocus: false,
      ariaLabel: 'Addressbackbutton',
      ariaHidden: false,
      className: 'Addressbackbutton',
      cssStyle:  { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500 }
    }

    let actualizarDatosWap = {
      id: 'actualizarDatosWap',
      type: 'button',
      name: 'Actualizar datos',
      value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.update.data'),
      classname: !this.state.enableUdpatebutton ? 'eventSubmitAddressbtnWap btnDisabled'  :"eventSubmitAddressbtnWap btnEnabled",
      onClickHandler: () => {
        // Handle clear filter action
        this.handleAddAddressTogift();
      },
      autoFocus: false,
      ariaLabel: 'actualizarDatosWap',
      ariaHidden: false,
      disabled:!this.state.enableUdpatebutton,
      cssStyle: this.state.enableUdpatebutton ? {
        backgroundColor: this.props.selectedTheme?.color_500,
        color: "#fff"
      } : {}
    }
    if (deliveryAddress && deliveryAddress.deliveryAddressInfo && deliveryAddress.deliveryAddressInfo.addresses) {

      return (
        <>
          <div>
            <div>
              <Tagging ref={tagging => this.tagging = tagging} />
              <ApplyCSS pageName={pageName} />
              <div className="myEventContent" style={{
                backgroundColor: '#FAFAFA',
              }}>

                <Warning2
                  // onClose
                  style={{ marginBottom: 25 }}
                  type={this.state.typeAlert}
                  ref={alertMessage => this.alertMessage = alertMessage}
                />

                <div
                  className="myEventInfo noBorder addressIntro oppeningContainer"
                  style={{
                    borderBottom: 'none',
                    width: (channel === 'web') ? '75%' : '100%',
                    // float: 'left',
                    textAlign: (channel === 'web') ? 'left' : "center",
                    marginBottom: 24,
                    position: 'relative',
                    left: 10
                  }}
                >
                  <h1 style={{
                    borderBottom: 'none', fontFamily: 'Roboto, sans-serif', fontSize: (channel === 'web') ? 20 : 16, fontWeight: 600, marginBottom: (channel === 'wap') ? 10 : 0, ...(channel === 'wap' && { marginTop: 24 }) 

                  }}>Mis direcciones de entrega</h1>
                  <span style={{
                    color: '#767676',
                    fontSize: (channel === 'web') ? 18 : 14,

                  }}>
                    Agrega hasta dos direcciones de entrega
                  </span>

                  {/* <p style={{ fontSize: 14 }}>{commonUtil.getLabel(lables.editEventDelivery, 'editEventDelivery.register.address.message', [deliveryAddress.deliveryAddressInfo.addressesToAdd])}
                  <br />{commonUtil.getLabel(lables.editEventDelivery, 'editEventDelivery.edit.address.in.store')}</p> */}
                </div>



                <div className="row equal-height" style={{ clear: 'both' }}>
                  <DeliveryAddressMultipleAddress
                    handleShowErrorOnCelebrityNoMapped={this.handleShowErrorOnCelebrityNoMapped}
                    setCelebrityNameForNewAddress={this.setCelebrityNameForNewAddress}
                    ref={addressReference => this.addressReference = addressReference}
                    cancelAddressModified={this.cancelAddressModified}
                    hasAddressModified={this.hasAddressModified}
                    deliveryAddress={deliveryAddress.deliveryAddressInfo}
                    eventStatusForSuspended={eventStatusForSuspended}
                    lables={this.props.lables}
                    eventCategoryInfo={this.props.eventCategoryInfo}
                    userEventDetails={this.props.userEventDetails}
                    personSelectedToUpdateAddress={this.personSelectedToUpdateAddress}
                    handleMySelection={this.handleMySelection}
                    handleDefaultSelect={this.handleDefaultSelect}
                    defaultAddressid={defaultAddressid}
                    profileAddresses={profileAddresses || {}}
                  />
                </div>

                <div className='Address-submit-button-container'>
                  {
                    channel === 'web' && (
                      <div style={{
                        display: 'flex',
                        float: 'right',
                        flexDirection: 'column'
                      }}>
                        <AddAditionalAddressButton
                          addressesToAdd={deliveryAddress.deliveryAddressInfo.addressesToAdd}
                          addAddress={this.addAddress}
                          enableAddAddressButton={enableAddAddressButton}
                          lables={lables}
                          selectedTheme={this.props.selectedTheme}
                          eventStatusForSuspended={eventStatusForSuspended}
                        />
                       

                        <div style={{
                          float: 'right',
                          marginTop: 20,
                        }}>
                           <InputButton  buttonAttr={actualizarDatos}/> 
                        </div>


                      </div>
                    )
                  }
                </div>


                {/* <ButtonsFooter
                cancelAddressModified={this.cancelAddressModified}
                hanldeAddressCelebrityMapping={this._hanldeAddressCelebrityMapping}
                setRef={this.setRef}
                isModified={this.state.isModified}
                addressesToAdd={deliveryAddress.deliveryAddressInfo.addressesToAdd}
              /> */}

                {
                  channel === 'wap' && (

                    <>
                      <AddAditionalAddressButton
                        addressesToAdd={deliveryAddress.deliveryAddressInfo.addressesToAdd}
                        addAddress={this.addAddress}
                        enableAddAddressButton={enableAddAddressButton}
                        lables={lables}
                        selectedTheme={this.props.selectedTheme}
                        eventStatusForSuspended={eventStatusForSuspended}
                      />

                      <div className='Address-submit-button-container-wap'>
                        <div>
                          <InputButton buttonAttr={Addressbackbutton} />
                        </div>

                        <div>
                          <InputButton buttonAttr={actualizarDatosWap} />

                        </div>
                      </div>
                    </>
                  )
                }

              </div>
            </div>
          </div>
        </>
      );
    }

    return (
      <div>
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName={pageName} />
        {/* <Warning
          type={'error'}
          textMessage={'Ninguna dirección asociada a este evento'}
        /> */}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  lables: state.labels.data,
  deliveryAddress: state.deliveryAddress.data,
  giftRegistryNewAddress: state.deliveryAddress,
  userEventDetails: state.eventDetails.userEventDetails,
  user: state.user.data,
  stateList: state.deliveryAddress.stateData,
  eventStatus: state.eventDetail.data?.eventList,
  eventCategoryInfo: state.eventcategory.data.eventConfigurations,
  giftRegistryAddress: state.giftRegistryAddress.data,
  eventManagementAddresses: state.deliveryAddress.eventManagementAddresses,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getDeliveryAddressInfo, getAddressData, getState, resetAddress, flushAddressSearch,updateEventDeliveryAddress,loadProfileAddress }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(DeliveryAddress);

